import { Actions } from './digitization.actions'
import { fromJS } from 'immutable'
import * as digitizationTypes from './digitization.types'

export const initialState = fromJS<any>({
  updateBuilding: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function digitizationReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case digitizationTypes.FETCH_BUILDING_REQUEST: {
      return state.setIn(['updateBuilding', 'isLoading'], true)
    }

    case digitizationTypes.FETCH_BUILDING_SUCCESS: {
      return state
        .setIn(['updateBuilding', 'isLoading'], false)
        .setIn(['updateBuilding', 'data'], fromJS(action.payload))
    }

    case digitizationTypes.FETCH_BUILDING_FAILURE: {
      return state.setIn(['updateBuilding', 'isLoading'], false)
    }

    case digitizationTypes.UPDATE_BUILDING_REQUEST: {
      return state
        .setIn(['updateBuilding', 'isLoading'], true)
        .setIn(['updateBuilding', 'validationErrors'], {})
    }

    case digitizationTypes.UPDATE_BUILDING_SUCCESS: {
      return state
        .setIn(['updateBuilding', 'isLoading'], false)
        .setIn(['updateBuilding', 'data'], fromJS(action.payload))
    }

    case digitizationTypes.UPDATE_BUILDING_FAILURE: {
      return state.setIn(['updateBuilding', 'isLoading'], false)
    }

    case digitizationTypes.CREATE_BUILDING_REQUEST: {
      return state
        .setIn(['updateBuilding', 'isLoading'], true)
        .setIn(['updateBuilding', 'validationErrors'], {})
    }

    case digitizationTypes.CREATE_BUILDING_SUCCESS: {
      return state
        .setIn(['updateBuilding', 'isLoading'], false)
        .setIn(['updateBuilding', 'data'], fromJS(action.payload))
    }

    case digitizationTypes.CREATE_BUILDING_FAILURE: {
      return state.setIn(['updateBuilding', 'isLoading'], false)
    }

    case digitizationTypes.UPDATE_FIELD:
      let fields: any[] = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case digitizationTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
